export default {
  layout: {
    default: [
      '& é " \' ( - è _ ç à ) = {bksp}',
      'a z e r t y u i o p $',
      'q s d f g h j k l m ù',
      '{shift} < w x c v b n , ; : ! {shift}',
      '@ {space}',
    ],
    shift: [
      '1 2 3 4 5 6 7 8 9 0 ° + {bksp}',
      'A Z E R T Y U I O P £',
      'Q S D F G H J K L M %',
      '{shift} > W X C V B N ? . / § {shift}',
      '@ {space}',
    ],
  },
};
